import { css } from '@emotion/react'
import styled from '@emotion/styled'

const COLOR_MAP = {
  active: 'p600',
  inactive: 'n200',
  canceled: 'r600',
  partial: 'y500'
}

const wrapperStyles = ({ theme }) => css`
  label: step-wrapper;

  display: flex;

  ${theme.media.kilo} {
    margin-bottom: ${theme.spacings.giga};
  }
`

const stepStyles = ({ theme, isActive }) => css`
  label: step;

  position: relative;

  min-height: 80px;
  width: 100%;

  margin: 0 auto;

  text-align: center;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: calc(${theme.spacings.giga} - 7px);

    height: 4px;
    width: 50%;

    background-color: ${isActive ? theme.colors.p600 : theme.colors.n200};

    transform: translateY(-50%);

    z-index: 0;
  }

  &::before {
    left: -1px;
  }

  &::after {
    right: -1px;
  }

  &:first-of-type::before,
  &:last-of-type::after {
    display: none;
  }

  ${theme.media.kilo} {
    &::before,
    &::after {
      top: calc(${theme.spacings.giga} - ${theme.spacings.bit});
    }
  }
`

const currentStepStyles = ({ theme, isCurrent }) =>
  isCurrent &&
  css`
    label: step--current;

    &::after {
      background-color: ${theme.colors.n200};
    }
  `

const bulletStyles = ({ theme, status, isDark }) => {
  const color = COLOR_MAP[status]

  return css`
    label: step__bullet;

    position: relative;

    display: inline-block;

    height: 35px;
    width: 35px;

    padding-top: calc(${theme.spacings.byte} - 1px);

    background-color: ${theme.colors[color]};
    border-radius: ${theme.borderRadius.circle};

    color: ${isDark ? theme.colors.n900 : theme.colors.white};

    z-index: 1;

    ${theme.media.kilo} {
      height: 40px;
      width: 40px;

      padding-top: ${theme.spacings.byte};
    }
  `
}

const descriptionStyles = ({ theme, isDark }) => css`
  label: step__description;

  display: flex;
  flex-direction: column;

  margin-top: ${theme.spacings.byte};

  color: ${isDark ? theme.colors.n900 : theme.colors.n400};
`

export const Wrapper = styled('div')(wrapperStyles)
export const Step = styled('div')(stepStyles, currentStepStyles)
export const Bullet = styled('div')(bulletStyles)
export const Description = styled('div')(descriptionStyles)
